import * as moment_ from 'moment';
import { Component, Input, Output, EventEmitter, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function NgxCalendarComponent_div_1_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const c_r4 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(c_r4);
} }
const _c0 = function (a0, a1) { return { "c-calendar-month-column-active": a0, "c-calendar-month-column-has-event": a1 }; };
function NgxCalendarComponent_div_1_div_16_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵlistener("click", function NgxCalendarComponent_div_1_div_16_div_1_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r9); const c_r7 = restoredCtx.$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.chooseDate(c_r7.date); });
    ɵngcc0.ɵɵelementStart(1, "span", 18);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const c_r7 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(2, _c0, ctx_r6.isSameDate(c_r7.date, ctx_r6.calendar.chosenDate), ctx_r6.hasEvent(c_r7.date)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(c_r7.formattedDate);
} }
function NgxCalendarComponent_div_1_div_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, NgxCalendarComponent_div_1_div_16_div_1_Template, 3, 5, "div", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", r_r5.columns);
} }
function NgxCalendarComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 2)(2, "div", 3)(3, "div", 4)(4, "div", 5);
    ɵngcc0.ɵɵlistener("click", function NgxCalendarComponent_div_1_Template_div_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.prevMonth(); });
    ɵngcc0.ɵɵtext(5, "<");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(9, "div", 8)(10, "div", 5);
    ɵngcc0.ɵɵlistener("click", function NgxCalendarComponent_div_1_Template_div_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.nextMonth(); });
    ɵngcc0.ɵɵtext(11, ">");
    ɵngcc0.ɵɵelementEnd()()();
    ɵngcc0.ɵɵelementStart(12, "div", 9)(13, "div", 7);
    ɵngcc0.ɵɵtemplate(14, NgxCalendarComponent_div_1_div_14_Template, 3, 1, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(15, "div", 11);
    ɵngcc0.ɵɵtemplate(16, NgxCalendarComponent_div_1_div_16_Template, 2, 1, "div", 12);
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.calendar.data.formattedDate);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.calendar.data.columns);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.calendar.data.rows);
} }
const _c1 = function (a0, a1) { return { "c-calendar-week-item-actionable": a0, "c-calendar-week-item-active": a1 }; };
function NgxCalendarComponent_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 24);
    ɵngcc0.ɵɵlistener("click", function NgxCalendarComponent_div_2_div_7_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r17); const c_r15 = restoredCtx.$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return !ctx_r16.calendar.options.isWithTime && ctx_r16.chooseDate(c_r15.date); });
    ɵngcc0.ɵɵelementStart(1, "div", 25)(2, "div", 26);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 27);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd()()();
} if (rf & 2) {
    const c_r15 = ctx.$implicit;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c1, !ctx_r13.calendar.options.isWithTime, ctx_r13.isSameDate(c_r15.date, ctx_r13.calendar.chosenDate)));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(c_r15.dayName);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(c_r15.formattedDate);
} }
const _c2 = function (a0) { return { "c-calendar-week-time-time-active": a0 }; };
function NgxCalendarComponent_div_2_div_8_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 33);
    ɵngcc0.ɵɵlistener("click", function NgxCalendarComponent_div_2_div_8_div_1_div_2_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r23); const r_r21 = restoredCtx.$implicit; const ctx_r22 = ɵngcc0.ɵɵnextContext(4); return ctx_r22.chooseDate(r_r21.date); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const r_r21 = ctx.$implicit;
    const ctx_r20 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c2, ctx_r20.isSameDateTime(r_r21.date, ctx_r20.calendar.chosenDate)));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(r_r21.formattedDate);
} }
function NgxCalendarComponent_div_2_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 30)(1, "div", 31);
    ɵngcc0.ɵɵtemplate(2, NgxCalendarComponent_div_2_div_8_div_1_div_2_Template, 2, 4, "div", 32);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const c_r19 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", c_r19.rows);
} }
function NgxCalendarComponent_div_2_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵtemplate(1, NgxCalendarComponent_div_2_div_8_div_1_Template, 3, 1, "div", 29);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r14.calendar.data.columns);
} }
const _c3 = function (a0) { return { "c-calendar-arrow-disabled": a0 }; };
function NgxCalendarComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div")(1, "div", 19)(2, "div", 4)(3, "div", 20);
    ɵngcc0.ɵɵlistener("click", function NgxCalendarComponent_div_2_Template_div_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(); return ctx_r24.prevWeek(); });
    ɵngcc0.ɵɵtext(4, "<");
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelementStart(5, "div", 6)(6, "div", 21);
    ɵngcc0.ɵɵtemplate(7, NgxCalendarComponent_div_2_div_7_Template, 6, 6, "div", 22);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(8, NgxCalendarComponent_div_2_div_8_Template, 2, 1, "div", 23);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 8)(10, "div", 20);
    ɵngcc0.ɵɵlistener("click", function NgxCalendarComponent_div_2_Template_div_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.nextWeek(); });
    ɵngcc0.ɵɵtext(11, ">");
    ɵngcc0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c3, ctx_r1.isPrevDisabled()));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.calendar.data.columns);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.calendar.options.isWithTime);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(6, _c3, ctx_r1.isNextDisabled()));
} }
const moment = moment_;
class NgxCalendarComponent {
    constructor() {
        this.onChooseDate = new EventEmitter();
        this.onChangeDate = new EventEmitter();
        this.viewEnum = {
            month: 1,
            week: 2
        };
        this.calendar = {
            options: {},
            defaults: {
                hourInterval: 1,
                minuteInterval: 0,
                fromHour: 0,
                toHour: 23
            }
        };
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.onInitOptions();
        this.setView(!this.calendar.options.isWeek);
    }
    /**
     * @return {?}
     */
    onInitOptions() {
        Object.assign(this.calendar.options, this.calendar.defaults);
        if (this.options) {
            Object.assign(this.calendar.options, this.options);
        }
        if (this.calendar.options.isFromNow) {
            this.calendar.options.fromDate = moment();
        }
        if (!this.calendar.options.hourInterval || !this.calendar.options.minuteInterval ||
            (this.calendar.options.hourInterval <= 0 && this.calendar.options.minuteInterval <= 0)) {
            this.calendar.options.hourInterval = this.calendar.defaults.hourInterval;
            this.calendar.options.minuteInterval = this.calendar.defaults.minuteInterval;
        }
    }
    /**
     * @return {?}
     */
    refresh() {
        this.onInitOptions();
        this.chooseDate();
        this.setView(this.isMonthView());
    }
    /**
     * @return {?}
     */
    isMonthView() {
        return this.calendar.view == this.viewEnum.month;
    }
    /**
     * @return {?}
     */
    isWeekView() {
        return this.calendar.view == this.viewEnum.week;
    }
    /**
     * @return {?}
     */
    isPrevDisabled() {
        if (!this.calendar.data.date || !this.calendar.options.fromDate) {
            return false;
        }
        if (this.isMonthView()) {
            //TODO: Add disable condition for month view.
            return false;
        }
        if (this.isWeekView()) {
            /** @type {?} */
            var prevWeekDate = this.calendar.data.date.clone();
            return prevWeekDate < this.calendar.options.fromDate;
        }
        return false;
    }
    /**
     * @return {?}
     */
    isNextDisabled() {
        if (!this.calendar.data.date || !this.calendar.options.toDate) {
            return false;
        }
        if (this.isMonthView()) {
            //TODO: Add disable condition for month view.
            return false;
        }
        if (this.isWeekView()) {
            /** @type {?} */
            var nextWeekDate = this.calendar.data.date.clone().add(1, "w");
            return nextWeekDate > this.calendar.options.toDate;
        }
        return false;
    }
    /**
     * @param {?} isMonth
     * @return {?}
     */
    setView(isMonth) {
        if (isMonth) {
            this.setMonth(this.calendar.chosenDate);
        }
        else {
            this.setWeek(this.calendar.chosenDate);
        }
    }
    /**
     * @param {?} date
     * @return {?}
     */
    setWeek(date) {
        this.calendar.data = {
            columns: []
        };
        this.calendar.view = this.viewEnum.week;
        date = moment(date).startOf("week");
        this.calendar.data.date = date.clone();
        for (var i = 0; i < 7; i++) {
            /** @type {?} */
            var column = {
                date: date.clone(),
                dayName: date.format("ddd"),
                formattedDate: date.format("DD/MM"),
                rows: []
            };
            if (this.calendar.options.isWithTime) {
                /** @type {?} */
                var time = column.date.clone().hour(this.calendar.options.fromHour);
                for (;;) {
                    if (time.date() != column.date.date() || time.hour() > this.calendar.options.toHour ||
                        (time.hour() == this.calendar.options.toHour && time.minute() > 0)) {
                        break;
                    }
                    /** @type {?} */
                    var isValid = true;
                    if (this.calendar.options.fromDate && time < this.calendar.options.fromDate) {
                        isValid = false;
                    }
                    if (this.calendar.options.toDate && time > this.calendar.options.toDate) {
                        isValid = false;
                    }
                    if (isValid) {
                        /** @type {?} */
                        var row = {
                            date: time,
                            formattedDate: time.format("HH:mm")
                        };
                        column.rows.push(row);
                    }
                    time = time.clone().add(this.calendar.options.hourInterval, "h").add(this.calendar.options.minuteInterval, "m");
                }
            }
            this.calendar.data.columns.push(column);
            date.add(1, "d");
        }
        this.setChangeDate();
    }
    /**
     * @return {?}
     */
    prevWeek() {
        this.setWeek(this.calendar.data.date.subtract(1, "w"));
    }
    /**
     * @return {?}
     */
    nextWeek() {
        this.setWeek(this.calendar.data.date.add(1, "w"));
    }
    /**
     * @param {?} date1
     * @param {?} date2
     * @return {?}
     */
    isSameDate(date1, date2) {
        if (!date1 || !date2) {
            return false;
        }
        return date1.isSame(date2, "day");
    }
    /**
     * @param {?} date1
     * @param {?} date2
     * @return {?}
     */
    isSameDateTime(date1, date2) {
        if (!this.isSameDate(date1, date2)) {
            return false;
        }
        return date1.isSame(date2, "hour") && date1.isSame(date2, "minute");
    }
    /**
     * @param {?=} date
     * @return {?}
     */
    chooseDate(date = null) {
        if (!date || (this.calendar.chosenDate &&
            ((!this.calendar.options.isWithTime && this.isSameDate(this.calendar.chosenDate, date)) || (this.calendar.options.isWithTime && this.isSameDateTime(this.calendar.chosenDate, date))))) {
            this.calendar.chosenDate = undefined;
        }
        else {
            this.calendar.chosenDate = date.clone();
        }
        if (this.onChooseDate) {
            if (this.calendar.chosenDate) {
                this.onChooseDate.emit(this.calendar.chosenDate.clone());
            }
            else {
                this.onChooseDate.emit(null);
            }
        }
    }
    /**
     * @param {?} date
     * @return {?}
     */
    setMonth(date) {
        this.calendar.data = {
            columns: moment.weekdaysShort(true),
            rows: []
        };
        this.calendar.view = this.viewEnum.month;
        date = moment(date).startOf("month");
        this.calendar.data.date = date.clone();
        this.calendar.data.formattedDate = this.calendar.data.date.format("MMMM YYYY");
        date = date.startOf("week");
        for (var i = 0; i < 5; i++) {
            /** @type {?} */
            var row = {
                columns: []
            };
            for (var j = 0; j < 7; j++) {
                /** @type {?} */
                var column = {
                    date: date.clone(),
                    formattedDate: date.format("DD")
                };
                row.columns.push(column);
                date.add(1, "d");
            }
            this.calendar.data.rows.push(row);
        }
        this.setChangeDate();
    }
    /**
     * @return {?}
     */
    prevMonth() {
        this.setMonth(this.calendar.data.date.subtract(1, "M"));
    }
    /**
     * @return {?}
     */
    nextMonth() {
        this.setMonth(this.calendar.data.date.add(1, "M"));
    }
    /**
     * @param {?} date
     * @return {?}
     */
    hasEvent(date) {
        if (!date) {
            return false;
        }
        if (!this.events || !this.events.length) {
            return false;
        }
        return this.events.some((/**
         * @param {?} val
         * @return {?}
         */
        (val) => this.isSameDate(date, val)));
    }
    /**
     * @return {?}
     */
    setChangeDate() {
        /** @type {?} */
        var model = {};
        if (this.isMonthView()) {
            /** @type {?} */
            var fromDate = this.calendar.data.rows[0].columns[0];
            if (fromDate) {
                model.fromDate = fromDate.date.clone();
            }
            if (model.fromDate) {
                /** @type {?} */
                var toDate = this.calendar.data.rows[this.calendar.data.rows.length - 1].columns[this.calendar.data.rows[this.calendar.data.rows.length - 1].columns.length - 1];
                if (toDate) {
                    model.toDate = toDate.date.clone();
                }
            }
        }
        if (this.isWeekView()) {
            /** @type {?} */
            var fromDate = this.calendar.data.columns[0];
            if (fromDate) {
                model.fromDate = fromDate.date.clone();
            }
            if (model.fromDate) {
                /** @type {?} */
                var toDate = this.calendar.data.columns[this.calendar.data.columns.length - 1];
                if (toDate) {
                    model.toDate = toDate.date.clone();
                }
            }
        }
        if (this.onChangeDate) {
            this.onChangeDate.emit(model);
        }
    }
}
NgxCalendarComponent.ɵfac = function NgxCalendarComponent_Factory(t) { return new (t || NgxCalendarComponent)(); };
NgxCalendarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxCalendarComponent, selectors: [["ngx-calendar"]], inputs: { options: "options", events: "events" }, outputs: { onChooseDate: "onChooseDate", onChangeDate: "onChangeDate" }, decls: 3, vars: 2, consts: [[1, "c-calendar"], [4, "ngIf"], [1, "c-calendar-month"], [1, "c-calendar-month-1"], [1, "c-calendar-left"], [1, "c-calendar-arrow", 3, "click"], [1, "c-calendar-middle"], [1, "c-calendar-month-header"], [1, "c-calendar-right"], [1, "c-calendar-month-2"], ["class", "c-calendar-month-item", 4, "ngFor", "ngForOf"], [1, "c-calendar-month-body"], ["class", "c-calendar-month-row", 4, "ngFor", "ngForOf"], [1, "c-calendar-month-item"], [1, "c-calendar-month-date"], [1, "c-calendar-month-row"], ["class", "c-calendar-month-item", 3, "click", 4, "ngFor", "ngForOf"], [1, "c-calendar-month-item", 3, "click"], [1, "c-calendar-month-column", 3, "ngClass"], [1, "c-calendar-week"], [1, "c-calendar-arrow", 3, "ngClass", "click"], [1, "c-calendar-week-header"], ["class", "c-calendar-week-item", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "c-calendar-week-body", 4, "ngIf"], [1, "c-calendar-week-item", 3, "ngClass", "click"], [1, "c-calendar-week-date"], [1, "c-calendar-week-date-name"], [1, "c-calendar-week-date-date"], [1, "c-calendar-week-body"], ["class", "c-calendar-week-item", 4, "ngFor", "ngForOf"], [1, "c-calendar-week-item"], [1, "c-calendar-week-time"], ["class", "c-calendar-week-time-time", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "c-calendar-week-time-time", 3, "ngClass", "click"]], template: function NgxCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NgxCalendarComponent_div_1_Template, 17, 3, "div", 1);
        ɵngcc0.ɵɵtemplate(2, NgxCalendarComponent_div_2_Template, 12, 8, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isMonthView());
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isWeekView());
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgClass], styles: ["@import url(https://fonts.googleapis.com/css?family=Roboto+Condensed);.c-calendar[_ngcontent-%COMP%]{font-family:'Roboto Condensed',sans-serif}.c-calendar[_ngcontent-%COMP%]   .c-calendar-right[_ngcontent-%COMP%]{text-align:right}.c-calendar[_ngcontent-%COMP%]   .c-calendar-middle[_ngcontent-%COMP%]{margin:0 8px}.c-calendar[_ngcontent-%COMP%]   .c-calendar-arrow[_ngcontent-%COMP%]{font-size:20px;cursor:pointer}.c-calendar[_ngcontent-%COMP%]   .c-calendar-arrow.c-calendar-arrow-disabled[_ngcontent-%COMP%]{pointer-events:none;opacity:.5}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]{display:-webkit-box;display:flex}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-left[_ngcontent-%COMP%], .c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-right[_ngcontent-%COMP%]{width:25px;height:50px;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-middle[_ngcontent-%COMP%]{width:calc(100% - 50px)}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-right[_ngcontent-%COMP%]{-webkit-box-pack:end;justify-content:flex-end}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-arrow[_ngcontent-%COMP%]{width:25px;height:25px;background-color:#e53935;border-radius:100%;color:#fff;text-align:center;line-height:25px}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-header[_ngcontent-%COMP%]{display:-webkit-box;display:flex;margin-bottom:8px;border-radius:4px;background-color:#e53935;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);color:#fff}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-body[_ngcontent-%COMP%]{display:-webkit-box;display:flex;padding:8px 0;border-radius:4px;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-header[_ngcontent-%COMP%]   .c-calendar-week-item[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-flex:1;flex-grow:1;flex-basis:0;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;text-align:center;height:50px;border-right:2px solid #fff}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-header[_ngcontent-%COMP%]   .c-calendar-week-item.c-calendar-week-item-actionable[_ngcontent-%COMP%]{border-bottom:2px solid transparent;padding-top:3px;cursor:pointer}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-header[_ngcontent-%COMP%]   .c-calendar-week-item.c-calendar-week-item-active[_ngcontent-%COMP%], .c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-header[_ngcontent-%COMP%]   .c-calendar-week-item[_ngcontent-%COMP%]:hover{border-bottom-color:#fff}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-header[_ngcontent-%COMP%]   .c-calendar-week-item[_ngcontent-%COMP%]:last-child{border-right:none}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-header[_ngcontent-%COMP%]   .c-calendar-week-item[_ngcontent-%COMP%]   .c-calendar-week-date[_ngcontent-%COMP%]   .c-calendar-week-date-name[_ngcontent-%COMP%]{font-size:16px;text-transform:uppercase}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-header[_ngcontent-%COMP%]   .c-calendar-week-item[_ngcontent-%COMP%]   .c-calendar-week-date[_ngcontent-%COMP%]   .c-calendar-week-date-date[_ngcontent-%COMP%]{font-size:16px}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-body[_ngcontent-%COMP%]   .c-calendar-week-item[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-flex:1;flex-grow:1;flex-basis:0;-webkit-box-pack:center;justify-content:center;text-align:center}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-body[_ngcontent-%COMP%]   .c-calendar-week-item[_ngcontent-%COMP%]   .c-calendar-week-time[_ngcontent-%COMP%]   .c-calendar-week-time-time[_ngcontent-%COMP%]{font-size:16px;border-bottom:2px solid transparent;margin-bottom:3px;cursor:pointer}.c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-body[_ngcontent-%COMP%]   .c-calendar-week-item[_ngcontent-%COMP%]   .c-calendar-week-time[_ngcontent-%COMP%]   .c-calendar-week-time-time.c-calendar-week-time-time-active[_ngcontent-%COMP%], .c-calendar[_ngcontent-%COMP%]   .c-calendar-week[_ngcontent-%COMP%]   .c-calendar-week-body[_ngcontent-%COMP%]   .c-calendar-week-item[_ngcontent-%COMP%]   .c-calendar-week-time[_ngcontent-%COMP%]   .c-calendar-week-time-time[_ngcontent-%COMP%]:hover{border-color:#e53935}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-1[_ngcontent-%COMP%]{display:-webkit-box;display:flex;border-radius:4px;padding:8px;margin-bottom:8px;background-color:#e53935;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);color:#fff;-webkit-box-pack:justify;justify-content:space-between}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-1[_ngcontent-%COMP%]   .c-calendar-month-header[_ngcontent-%COMP%]{text-align:center;text-transform:uppercase;font-size:20px}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-2[_ngcontent-%COMP%]{padding:16px;border-radius:4px;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-2[_ngcontent-%COMP%]   .c-calendar-month-header[_ngcontent-%COMP%]{display:-webkit-box;display:flex;margin-bottom:8px;border-bottom:2px solid #e53935;padding-bottom:8px}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-2[_ngcontent-%COMP%]   .c-calendar-month-header[_ngcontent-%COMP%]   .c-calendar-month-item[_ngcontent-%COMP%]{-webkit-box-flex:1;flex-grow:1;flex-basis:0;-webkit-box-pack:center;justify-content:center;text-align:center}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-2[_ngcontent-%COMP%]   .c-calendar-month-header[_ngcontent-%COMP%]   .c-calendar-month-item[_ngcontent-%COMP%]   .c-calendar-month-date[_ngcontent-%COMP%]{font-size:16px;text-transform:uppercase}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-2[_ngcontent-%COMP%]   .c-calendar-month-body[_ngcontent-%COMP%]   .c-calendar-month-row[_ngcontent-%COMP%]{display:-webkit-box;display:flex;flex-wrap:wrap}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-2[_ngcontent-%COMP%]   .c-calendar-month-body[_ngcontent-%COMP%]   .c-calendar-month-row[_ngcontent-%COMP%]   .c-calendar-month-item[_ngcontent-%COMP%]{-webkit-box-flex:1;flex-grow:1;flex-basis:0;-webkit-box-pack:center;justify-content:center;text-align:center;cursor:pointer;margin-top:8px}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-2[_ngcontent-%COMP%]   .c-calendar-month-body[_ngcontent-%COMP%]   .c-calendar-month-row[_ngcontent-%COMP%]   .c-calendar-month-column[_ngcontent-%COMP%]{font-size:16px;border-bottom:2px solid transparent;margin-bottom:3px}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-2[_ngcontent-%COMP%]   .c-calendar-month-body[_ngcontent-%COMP%]   .c-calendar-month-row[_ngcontent-%COMP%]   .c-calendar-month-column.c-calendar-month-column-active[_ngcontent-%COMP%], .c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-2[_ngcontent-%COMP%]   .c-calendar-month-body[_ngcontent-%COMP%]   .c-calendar-month-row[_ngcontent-%COMP%]   .c-calendar-month-item[_ngcontent-%COMP%]:hover   .c-calendar-month-column[_ngcontent-%COMP%]{border-color:#e53935}.c-calendar[_ngcontent-%COMP%]   .c-calendar-month[_ngcontent-%COMP%]   .c-calendar-month-2[_ngcontent-%COMP%]   .c-calendar-month-body[_ngcontent-%COMP%]   .c-calendar-month-row[_ngcontent-%COMP%]   .c-calendar-month-column.c-calendar-month-column-has-event[_ngcontent-%COMP%]{color:#e53935}"] });
NgxCalendarComponent.propDecorators = {
    options: [{ type: Input }],
    events: [{ type: Input }],
    onChooseDate: [{ type: Output }],
    onChangeDate: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCalendarComponent, [{
        type: Component,
        args: [{
                selector: "ngx-calendar",
                template: "<div class=\"c-calendar\">\r\n    <div *ngIf=\"isMonthView()\">\r\n        <div class=\"c-calendar-month\">\r\n            <div class=\"c-calendar-month-1\">\r\n                <div class=\"c-calendar-left\">\r\n                    <div class=\"c-calendar-arrow\" (click)=\"prevMonth()\"><</div>\r\n                </div>\r\n                <div class=\"c-calendar-middle\">\r\n                    <div class=\"c-calendar-month-header\">{{calendar.data.formattedDate}}</div>\r\n                </div>\r\n                <div class=\"c-calendar-right\">\r\n                    <div class=\"c-calendar-arrow\" (click)=\"nextMonth()\">></div>\r\n                </div>\r\n            </div>\r\n            <div class=\"c-calendar-month-2\">\r\n                <div class=\"c-calendar-month-header\">\r\n                    <div *ngFor=\"let c of calendar.data.columns\" class=\"c-calendar-month-item\">\r\n                        <div class=\"c-calendar-month-date\">{{c}}</div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"c-calendar-month-body\">\r\n                    <div class=\"c-calendar-month-row\" *ngFor=\"let r of calendar.data.rows\">\r\n                        <div (click)=\"chooseDate(c.date)\" class=\"c-calendar-month-item\" *ngFor=\"let c of r.columns\">\r\n                            <span class=\"c-calendar-month-column\" [ngClass]=\"{'c-calendar-month-column-active': isSameDate(c.date, calendar.chosenDate), 'c-calendar-month-column-has-event': hasEvent(c.date)}\">{{c.formattedDate}}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div *ngIf=\"isWeekView()\">\r\n        <div class=\"c-calendar-week\">\r\n            <div class=\"c-calendar-left\">\r\n                <div class=\"c-calendar-arrow\" (click)=\"prevWeek()\" [ngClass]=\"{'c-calendar-arrow-disabled': isPrevDisabled()}\"><</div>\r\n            </div>\r\n            <div class=\"c-calendar-middle\">\r\n                <div class=\"c-calendar-week-header\">\r\n                    <div (click)=\"!calendar.options.isWithTime && chooseDate(c.date)\" *ngFor=\"let c of calendar.data.columns\" class=\"c-calendar-week-item\" [ngClass]=\"{'c-calendar-week-item-actionable': !calendar.options.isWithTime, 'c-calendar-week-item-active': isSameDate(c.date, calendar.chosenDate)}\">\r\n                        <div class=\"c-calendar-week-date\">\r\n                            <div class=\"c-calendar-week-date-name\">{{c.dayName}}</div>\r\n                            <div class=\"c-calendar-week-date-date\">{{c.formattedDate}}</div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div *ngIf=\"calendar.options.isWithTime\" class=\"c-calendar-week-body\">\r\n                    <div *ngFor=\"let c of calendar.data.columns\" class=\"c-calendar-week-item\">\r\n                        <div class=\"c-calendar-week-time\">\r\n                            <div *ngFor=\"let r of c.rows\" (click)=\"chooseDate(r.date)\" class=\"c-calendar-week-time-time\" [ngClass]=\"{'c-calendar-week-time-time-active': isSameDateTime(r.date, calendar.chosenDate)}\">{{r.formattedDate}}</div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div class=\"c-calendar-right\">\r\n                <div class=\"c-calendar-arrow\" (click)=\"nextWeek()\" [ngClass]=\"{'c-calendar-arrow-disabled': isNextDisabled()}\">></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>",
                styles: ["@import url(https://fonts.googleapis.com/css?family=Roboto+Condensed);.c-calendar{font-family:'Roboto Condensed',sans-serif}.c-calendar .c-calendar-right{text-align:right}.c-calendar .c-calendar-middle{margin:0 8px}.c-calendar .c-calendar-arrow{font-size:20px;cursor:pointer}.c-calendar .c-calendar-arrow.c-calendar-arrow-disabled{pointer-events:none;opacity:.5}.c-calendar .c-calendar-week{display:-webkit-box;display:flex}.c-calendar .c-calendar-week .c-calendar-left,.c-calendar .c-calendar-week .c-calendar-right{width:25px;height:50px;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.c-calendar .c-calendar-week .c-calendar-middle{width:calc(100% - 50px)}.c-calendar .c-calendar-week .c-calendar-right{-webkit-box-pack:end;justify-content:flex-end}.c-calendar .c-calendar-week .c-calendar-arrow{width:25px;height:25px;background-color:#e53935;border-radius:100%;color:#fff;text-align:center;line-height:25px}.c-calendar .c-calendar-week .c-calendar-week-header{display:-webkit-box;display:flex;margin-bottom:8px;border-radius:4px;background-color:#e53935;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);color:#fff}.c-calendar .c-calendar-week .c-calendar-week-body{display:-webkit-box;display:flex;padding:8px 0;border-radius:4px;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.c-calendar .c-calendar-week .c-calendar-week-header .c-calendar-week-item{display:-webkit-box;display:flex;-webkit-box-flex:1;flex-grow:1;flex-basis:0;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;text-align:center;height:50px;border-right:2px solid #fff}.c-calendar .c-calendar-week .c-calendar-week-header .c-calendar-week-item.c-calendar-week-item-actionable{border-bottom:2px solid transparent;padding-top:3px;cursor:pointer}.c-calendar .c-calendar-week .c-calendar-week-header .c-calendar-week-item.c-calendar-week-item-active,.c-calendar .c-calendar-week .c-calendar-week-header .c-calendar-week-item:hover{border-bottom-color:#fff}.c-calendar .c-calendar-week .c-calendar-week-header .c-calendar-week-item:last-child{border-right:none}.c-calendar .c-calendar-week .c-calendar-week-header .c-calendar-week-item .c-calendar-week-date .c-calendar-week-date-name{font-size:16px;text-transform:uppercase}.c-calendar .c-calendar-week .c-calendar-week-header .c-calendar-week-item .c-calendar-week-date .c-calendar-week-date-date{font-size:16px}.c-calendar .c-calendar-week .c-calendar-week-body .c-calendar-week-item{display:-webkit-box;display:flex;-webkit-box-flex:1;flex-grow:1;flex-basis:0;-webkit-box-pack:center;justify-content:center;text-align:center}.c-calendar .c-calendar-week .c-calendar-week-body .c-calendar-week-item .c-calendar-week-time .c-calendar-week-time-time{font-size:16px;border-bottom:2px solid transparent;margin-bottom:3px;cursor:pointer}.c-calendar .c-calendar-week .c-calendar-week-body .c-calendar-week-item .c-calendar-week-time .c-calendar-week-time-time.c-calendar-week-time-time-active,.c-calendar .c-calendar-week .c-calendar-week-body .c-calendar-week-item .c-calendar-week-time .c-calendar-week-time-time:hover{border-color:#e53935}.c-calendar .c-calendar-month .c-calendar-month-1{display:-webkit-box;display:flex;border-radius:4px;padding:8px;margin-bottom:8px;background-color:#e53935;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);color:#fff;-webkit-box-pack:justify;justify-content:space-between}.c-calendar .c-calendar-month .c-calendar-month-1 .c-calendar-month-header{text-align:center;text-transform:uppercase;font-size:20px}.c-calendar .c-calendar-month .c-calendar-month-2{padding:16px;border-radius:4px;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.c-calendar .c-calendar-month .c-calendar-month-2 .c-calendar-month-header{display:-webkit-box;display:flex;margin-bottom:8px;border-bottom:2px solid #e53935;padding-bottom:8px}.c-calendar .c-calendar-month .c-calendar-month-2 .c-calendar-month-header .c-calendar-month-item{-webkit-box-flex:1;flex-grow:1;flex-basis:0;-webkit-box-pack:center;justify-content:center;text-align:center}.c-calendar .c-calendar-month .c-calendar-month-2 .c-calendar-month-header .c-calendar-month-item .c-calendar-month-date{font-size:16px;text-transform:uppercase}.c-calendar .c-calendar-month .c-calendar-month-2 .c-calendar-month-body .c-calendar-month-row{display:-webkit-box;display:flex;flex-wrap:wrap}.c-calendar .c-calendar-month .c-calendar-month-2 .c-calendar-month-body .c-calendar-month-row .c-calendar-month-item{-webkit-box-flex:1;flex-grow:1;flex-basis:0;-webkit-box-pack:center;justify-content:center;text-align:center;cursor:pointer;margin-top:8px}.c-calendar .c-calendar-month .c-calendar-month-2 .c-calendar-month-body .c-calendar-month-row .c-calendar-month-column{font-size:16px;border-bottom:2px solid transparent;margin-bottom:3px}.c-calendar .c-calendar-month .c-calendar-month-2 .c-calendar-month-body .c-calendar-month-row .c-calendar-month-column.c-calendar-month-column-active,.c-calendar .c-calendar-month .c-calendar-month-2 .c-calendar-month-body .c-calendar-month-row .c-calendar-month-item:hover .c-calendar-month-column{border-color:#e53935}.c-calendar .c-calendar-month .c-calendar-month-2 .c-calendar-month-body .c-calendar-month-row .c-calendar-month-column.c-calendar-month-column-has-event{color:#e53935}"]
            }]
    }], function () { return []; }, { onChooseDate: [{
            type: Output
        }], onChangeDate: [{
            type: Output
        }], options: [{
            type: Input
        }], events: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxCalendarModule {
}
NgxCalendarModule.ɵfac = function NgxCalendarModule_Factory(t) { return new (t || NgxCalendarModule)(); };
NgxCalendarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxCalendarModule });
NgxCalendarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCalendarModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxCalendarComponent],
                imports: [CommonModule],
                exports: [NgxCalendarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxCalendarModule, { declarations: function () { return [NgxCalendarComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [NgxCalendarComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxCalendarComponent, NgxCalendarModule };

